export function useProductFilter() {
  const getFilterOptionLabel = (label: string) => {
    const correction = {
      true: 'Kyllä',
      false: 'Ei',
      Yes: 'Kyllä',
      No: 'Ei',
      rovaniemi: 'Rovaniemi',
      oulu: 'Oulu',
      ranua: 'Ranua',
      keskusvarasto: 'Keskusvarasto'
    }
    const reg = new RegExp('^(' + Object.keys(correction).join('|') + ')$', 'g')
    return label.replace(reg, (matched: string) => correction[matched as keyof typeof correction])
  }

  return {
    getFilterOptionLabel
  }
}
